export const findById = (data, id) => {
  return data ? data.find((d) => d.id === id) : null
}
